export const REVIEW_EVENTS = {
  SELECT_STORE_REVIEWS: "web_select_store_reviews",
};
